import React from 'react';
export function EstimateBanner() {
  return <section className="relative py-20 overflow-hidden" data-id="element-39">
      {/* Diagonal Stripe Background */}
      <div className="absolute inset-0 bg-sapper-olive" data-id="element-40" />
      <div className="absolute inset-0 opacity-20" style={{
      backgroundImage: 'repeating-linear-gradient(45deg, #0F1410 0, #0F1410 2px, transparent 2px, transparent 10px)'
    }} data-id="element-41" />

      <div className="container mx-auto px-4 sm:px-6 relative z-10 text-center" data-id="element-42">
        <h2 className="font-condensed font-black text-4xl sm:text-5xl md:text-6xl text-sapper-white uppercase tracking-tighter mb-4" data-id="element-43">
          GOT A WRITTEN ESTIMATE? BRING IT.
        </h2>
        <p className="font-sans text-lg sm:text-xl text-sapper-white/90 mb-8 max-w-2xl mx-auto" data-id="element-44">
          We'll match it or beat it. Period. Same equipment, better install,
          lower price.
        </p>

        <a href="#contact" className="inline-flex items-center justify-center bg-sapper-red text-sapper-white font-condensed font-bold text-xl px-10 py-5 uppercase tracking-wider hover:bg-sapper-dark transition-colors shadow-2xl" data-id="element-45">
          SUBMIT YOUR ESTIMATE
        </a>

        <p className="font-sans text-xs text-sapper-white/60 mt-6" data-id="element-46">
          * Subject to apples-to-apples comparison on equipment specs and
          warranty.
        </p>
      </div>
    </section>;
}